// extracted by mini-css-extract-plugin
module.exports = {"TherapySearchBar":"SearchBarForTherapy_TherapySearchBar__2nCGr"};